/**
 * Created by saha.moinak on 02/07/2020.
 */
import reducerRegistry from '@comeon/reducer-registry';
import { requestApi } from '~/services/api.js';

export const UPDATE_PLAYER_SOW_STATUS = '@komigen/mobile-frontend/sow/UPDATE_PLAYER_SOW_STATUS';
export const SOW_UPLOAD_FILES_STATUS = '@komigen/mobile-frontend/sow/SOW_UPLOAD_FILES_STATUS';
export const SOW_UPLOAD_FILES_ERROR = '@komigen/mobile-frontend/sow/SOW_UPLOAD_FILES_ERROR';
export const RESET_ALL_SOW = '@komigen/mobile-frontend/sow/RESET_ALL_SOW';

const REDUCER_NAME = 'sow';

const sowSelectorPlayerStatus = state => state[REDUCER_NAME].playerSOWStatus;
const sowSelectorUploadStatus = state => state[REDUCER_NAME].uploadFilesStatus;
const sowSelectorUploadError = state => state[REDUCER_NAME].uploadFilesError;

const getPlayerSOWStatus = () => {
	return async dispatch => {
		try {
			dispatch({
				type: UPDATE_PLAYER_SOW_STATUS,
				payload: `fetching`
			});
			const response = await requestApi('/rest/sow/status', 'GET');

			if (response.status === 'SUCCESS') {
				dispatch({
					type: UPDATE_PLAYER_SOW_STATUS,
					payload: response.result
				});
			} else {
				dispatch({
					type: UPDATE_PLAYER_SOW_STATUS,
					payload: '0'
				});
			}
		} catch (e) {
			dispatch({
				type: UPDATE_PLAYER_SOW_STATUS,
				payload: '1' // '1', '2' or '3' for testing, otherwise '0'
			});
			console.warn('Player SOW status Error', e); // eslint-disable-line
		}
	};
};

const uploadFiles = data => {
	return async dispatch => {
		try {
			dispatch({
				type: SOW_UPLOAD_FILES_STATUS,
				payload: 'loading'
			});

			const response = await fetch(`/rest/sow/docs`, {
				method: 'POST',
				body: data
			});

			if (response.status === 200) {
				dispatch({
					type: SOW_UPLOAD_FILES_STATUS,
					payload: 'success'
				});
			} else {
				dispatch({
					type: SOW_UPLOAD_FILES_ERROR,
					payload: response
				});

				dispatch({
					type: SOW_UPLOAD_FILES_STATUS,
					payload: null
				});
			}
		} catch (e) {
			dispatch({
				type: SOW_UPLOAD_FILES_STATUS,
				payload: null
			});

			dispatch({
				type: SOW_UPLOAD_FILES_ERROR,
				payload: e
			});
		}
	};
};

const resetUploadFileStatus = () => ({
	type: SOW_UPLOAD_FILES_STATUS,
	payload: null
});

const resetSOW = () => ({
	type: RESET_ALL_SOW
});

function reducer(
	state = {
		playerSOWStatus: '0',
		uploadFilesStatus: null,
		uploadFilesError: null
	},
	action
) {
	switch (action.type) {
		case UPDATE_PLAYER_SOW_STATUS:
			return {
				...state,
				playerSOWStatus: action.payload
			};

		case SOW_UPLOAD_FILES_STATUS:
			return {
				...state,
				uploadFilesStatus: action.payload
			};

		case SOW_UPLOAD_FILES_ERROR:
			return {
				...state,
				uploadFilesError: action.payload
			};

		case RESET_ALL_SOW:
			return {
				...state,
				playerSOWStatus: '0',
				uploadFilesStatus: null,
				uploadFilesError: null
			};

		default:
			return state;
	}
}

reducerRegistry.register(REDUCER_NAME, reducer);

export {
	getPlayerSOWStatus,
	sowSelectorPlayerStatus,
	sowSelectorUploadStatus,
	sowSelectorUploadError,
	resetSOW,
	uploadFiles,
	resetUploadFileStatus
};

export default reducer;
